import api from '../lib/api';

export const SETTINGS_LOADED = 'SETTINGS_LOADED';

export default {
  fetchSettings() {
    return (dispatch) => api.getSettings()
      .then((data) => {
        dispatch({ type: SETTINGS_LOADED, payload: data });
      });
  },
};
